export default __webpack_public_path__ + "0fe0cdc114f8b528295c5ee47fb91255.svg";